// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b0ed0119","453":"ff2a737b","732":"ad01b1ea"}[chunkId] + ".chunk.js";
};